import { GridCellCommonPropsType } from '../../../../enums';

export const CommonCellProps = {
  props: {
    cell: {
      default: () => ({}),
      type: Object,
    },
    options: {
      default: () => ({}),
      type: Object,
    },
    stickyPosition: {
      default: 0,
      type: Number,
    },
  },
};

export const CommonCellComputed = {
  computed: {
    commonCell() {
      return {
        [GridCellCommonPropsType.FillColorSchema]: (
          this.cell[GridCellCommonPropsType.FillColorSchema]
        ),
        [GridCellCommonPropsType.ColorSchema]: this.cell[GridCellCommonPropsType.ColorSchema],
        [GridCellCommonPropsType.Value]: this.cell[GridCellCommonPropsType.Value],
      };
    },
    value() {
      return this.cell[GridCellCommonPropsType.Value];
    },
  },
};
